/*
 *
 * PciResponsabilityModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 29-May-2025
*/

import PciResponsabilityModal from './PciResponsabilityModalContainer'

export default PciResponsabilityModal
